import axios from "axios";
import settings from "../../../../utils/settings";

const url = `${settings.accountsUrl}api/admin/news`;

export const deleteNews = (id) => {
    return axios.delete(`${url}/${id}`);
}


// WEBPACK FOOTER //
// ./src/views/pages/news/requests/deleteNew.js